import { render, staticRenderFns } from "./AddCheck.vue?vue&type=template&id=1aa5451e"
import script from "./AddCheck.vue?vue&type=script&lang=js"
export * from "./AddCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports